import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  () => ({
    root: {
      display: 'grid',
      width: '100%',
      gridTemplateColumns: '3fr 3fr 3fr 3fr',
      gridColumnGap: Spacings.s24,
      gridRowGap: Spacings.s48,

      [BreakPointsMedia.LG]: {
        gridTemplateColumns: '4fr 4fr 4fr 4fr',
      },
      [BreakPointsMedia.MD]: {
        gridTemplateColumns: '4fr 4fr 4fr 4fr',
      },
      [BreakPointsMedia.SM]: {
        gridTemplateColumns: '4fr 4fr 4fr 4fr',
      },
      [BreakPointsMedia.XS]: {
        gridTemplateColumns: '4fr 4fr 4fr 4fr',
      },
      [BreakPointsMedia.XS]: {
        gridTemplateColumns: '4fr 4fr 4fr 4fr',
      },
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        gridRowGap: Spacings.s40,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        gridTemplateColumns: '6fr 6fr',
        gridRowGap: Spacings.s24,
      },
    },
    column: {
      position: 'relative',
      minWidth: '100%',
      maxWidth: '100%',
      contain: 'layout',
    },
  }),
  {
    name: 'grid-list',
  },
);

export default useStyles;
